import { render, staticRenderFns } from "./EmpoweringBusiness2.vue?vue&type=template&id=62490044&scoped=true&"
import script from "./EmpoweringBusiness2.vue?vue&type=script&lang=js&"
export * from "./EmpoweringBusiness2.vue?vue&type=script&lang=js&"
import style0 from "./EmpoweringBusiness2.vue?vue&type=style&index=0&id=62490044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62490044",
  null
  
)

export default component.exports